import React from 'react'
import BulletPoint from '../../../../../components/bulletPoint/BulletPoint'

import './CustomizeDetails.scss'

const data = {
  title: 'Customer Service',
  desc:
    'We specialize in top-quality customer care, inbound sales, order-processing, technical support, customer relationship management, chat support and email response. Top brands turn to Virtual Enterprise to deliver a superior customer service experience at various customer touchpoints.',
  features: [
    'Inbound Sales',
    'Lead Generation and Qualification',
    'Reservations and Appointment Setting',
    'Outbound',
  ],
  price: 50,
  duration: 'per month',
}

const CustomizeDetails = () => {
  return (
    <div className="paymentDetails">
      <div className="paymentDetails__overview">Order Overview</div>
      <div className="paymentDetails__title">{data.title}</div>
      <div className="paymentDetails__desc">{data.desc}</div>
      {data.features.map((data) => (
        <BulletPoint type="regular" item={data} />
      ))}
      {/* <hr />
      <div className="paymentDetails__price">
        ${data.price}.00 <span className="paymentDetails__duration">{data.duration}</span>
      </div> */}
    </div>
  )
}

export default CustomizeDetails
